<template>
  <div class="animated fadeIn pt3 pb4 mb4">
    <div class="clearfix gibson px2 mb2">
      <!-- mobile setup -->
      <div class="col-12 px2" v-if="showMobile">
        <div class="clearfix border muted-border p2 py3 mb2 shadow">
          <div class="col-12 px2">
            <p class="h3 semi-bold line-height-2 my2 gibson darkblue">For få opgaver?</p>
            <p class="h4 gibson line-height-3 darkblue regular">– Stil din arbejdskraft til rådighed</p>
            <ul class="list-reset pl0 ml0 mt3">
              <li class="flex justify-start items-center">
                <span class="mr2">
                  <b-img width="16" src="static/img/sky-blue-checkmark.png"></b-img>
                </span>
                <p class="h5 gibson line-height-1 my1 darkblue regular">Udlån overskydende arbejdskraft</p>
              </li>
              <li class="flex justify-start items-center">
                <span class="mr2">
                  <b-img width="16" src="static/img/sky-blue-checkmark.png"></b-img>
                </span>
                <p class="h5 gibson line-height-1 my1 darkblue regular">Optimèr økonomien</p>
              </li>
              <li class="flex justify-start items-center">
                <span class="mr2">
                  <b-img width="16" src="static/img/sky-blue-checkmark.png"></b-img>
                </span>
                <p class="h5 gibson line-height-1 my1 darkblue regular">Bevar virksomhedens arbejdsstyrke</p>
              </li>
            </ul>
            <p class="h6 regular darkblue line-height-golden mb1 gibson">
              Mange virksomheder oplever i perioder, at de mangler opgaver for at have nok arbejde til alle ansatte. I Mester til Mester kan du stille overskydende arbejdskraft til rådighed for andre medlemmer.
              <span id="dots">...</span>
              <br><br>
              <span id="more">
                Ved at udlåne arbejdskraft er din virksomhed hele tiden i besiddelse af optimal arbejdsstyrke, men oplever ikke konsekvenserne af mangel på opgaver.
                <br><br>
                Når opgaverne kommer ind igen, har du stadig din arbejdsstyrke til at tage varetage opgaverne.
                <br><br>
                <strong class="semi-bold">Udlån arbejdskraft i god tid</strong>
                <br>
                Forventer du at mangle opgaver i bestemte perioder på året, kan du i god tid udlåne overskydende arbejdskraft. Det skaber vished og sikkerhed i virksomheden i perioder, hvor efterspørgslen ikke er så stor.
              </span>
            </p>
            <div @click="readMore()" id="moreBtn" class="clearfix">
              <div class="col-12 flex flex-column justify-center items-center">
                <div class="border muted-border shadow green center" style="height:32px;width:32px;border-radius:50%;line-height:32px;">
                  <span id="moreIcon">
                    <i class="el-icon-bottom" style="font-size:16px;"></i>
                  </span>
                  <span id="lessIcon">
                    <i class="el-icon-top" style="font-size:16px;"></i>
                  </span>
              </div>
              <p id="btnText" class="block center green h6 gibson line-height-1 mt1 mb0">Læs mere</p>
              </div>
            </div>
            <div class="col-12 px0 flex justify-start items-center my2">
              <button v-b-toggle.m2m class="col-12 p2 gibson outlined-dark-button not-rounded flex justify-center items-center hide">
                <span class="h4 mb0">Filter</span>
                <span class="flex-none when-closed ml2">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                  </span>
                </span>
                <span class="flex-none when-opened ml2">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <b-collapse id="m2m">
              <div class="clearfix my3">
                <div class="col-12 px0 flex justify-end items-center">
                  <button v-b-toggle.m2m class="white-button border-none not-rounded gibson">
                    <span>
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                    </span>
                  </button>
                </div>
                <div class="py1"></div>
                <b-form-checkbox id="sortByStatus" v-model="status" name="sortByStatus" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Kunder</span>
                </b-form-checkbox>
                <div class="clearfix"></div>
                <b-form-checkbox id="sortByHaveWork" v-model="status" name="sortByHaveWork" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Ledige arbejdskraft</span>
                </b-form-checkbox>
                <div class="clearfix"></div>
                <b-form-checkbox id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Extra opgaver</span>
                </b-form-checkbox>
                <div class="py1"></div>
                <div class="clearfix">
                  <button class="col-12 action-button p2 gibson not-rounded">
                    <span class="h6 mb0">Sorter nu</span>
                    <span class="ml1"><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </div>
            </b-collapse>
            <div class="col-12 px0 flex justify-between items-center mt4 mb2">
              <button v-b-toggle.createItem id="setKarft" class="p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h5 mb0">Opslå ledig arbejdskraft</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
              <button @click="OpenUrl('/markedsplads?mode=job')" id="seeAvailableJobs" class="p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h5 mb0">Se ledig arbejdskraft</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <!-- <div class="col-12 px0 flex justify-start items-center my2">
              <button v-b-toggle.createItem id="setKarft" class="col-12 p2 gibson outlined-action-button not-rounded flex justify-center items-center">
                <span class="h4 mb0">Opslå ledig arbejdskraft</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div> -->
            <div v-if="success">
            <b-alert show>
              <p class="h4 gibson semi-bold darkblue line-height-3">
                Gennemført!
              </p>
              <p class="h5 darkblue regular gibson line-height-golden" >
                Vi håndterer det så hurtigt som muligt
              </p>
            </b-alert>
            </div>
            <b-collapse  id="createItem">
              <form>
                <div class="clearfix mt3 mb2">
                  <p class="h4 darkblue gibson line-height-3">
                    Opslå ledige arbejdskraft
                  </p>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Vælg faggruppen
                  </p>
                    <v-select   v-model="opgave2" :options="opgaveoptions" required class="p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                      <template slot="no-options">
                        Ingen matchende ...
                      </template>
                    </v-select>
                    <div class="text-danger" v-if="validationErrors.opgave2 && opgave2 === ''" >Nødvendig</div>
                </div>

                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Antal ledige mænd
                  </p>
                  <input type="number" v-model="numofman2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12">
                  <div class="text-danger" v-if="validationErrors.numofman2 && numofman2 === ''" >Nødvendig</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h5  mediumgrey line-height-1 mb1">
                    Antal tilbud på arbejdskraften
                  </p>
                  <select v-model="offer2" class="lightgrey-background col-12 h5 darkblue px2 py1 outline-none border-none">
                    <option value='3' selected>3 Tilbud</option>
                    <option value='2'>2 Tilbud</option>
                    <option value='1'>1 Tilbud</option>
                  </select>
                  <div class="text-danger" v-if="validationErrors.numofman1 && numofman1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Postnummer (hvor er arbejdskraften)
                  </p>
                  <input type="number" v-model="postnumber2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.postnumber2 && postnumber2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Opstartsdato
                  </p>
                  <date-picker id="ferieStart" type="text" required v-model="startdate2" :config="config" required class="muted-background gibson border-none not-rounded"></date-picker>
                  <div class="text-danger" v-if="validationErrors.startdate2 && startdate2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Timepris inkl. alt (ex. moms)
                  </p>
                  <input type="text" v-model="timepris2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.timepris2 && timepris2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Skriv om dig
                  </p>
                  <textarea v-model="desc2" class="p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none" style="min-height:120px;" placeholder="Short description"></textarea>
                  <div class="text-danger" v-if="validationErrors.desc2 && desc2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Billeder
                  </p>
                  <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="image in images" :key="image">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                      <button  @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb2">
                  <button type="button" @click="getdataigibility()" class="col-12 action-button p2 gibson h5 flex justify-center items-center">
                    <span>Fortsæt</span>
                    <span class="ml2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                </div>
              </form>
            </b-collapse>
          </div>
          <div class="col-12 px2">
              <div class="clearfix mt2">
                <div class="col-12 px0 pb3 mt4 mb3 border-bottom muted-border" v-for="item in jobs">
                  <button v-b-toggle="'workDetails'+item.id" class="col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1">
                    <div>
                      <svg fill="currentColor" width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"/><path d="M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"/><path d="M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"/></svg>
                    </div>
                    <div class="flex-auto pl2">
                      <p class="darkblue mb0 line-height-1 left-align">
                        <span class="h4 block">Arbejdskraft</span>
                        <span class="h6 regular">Startdato: {{ moment(item.startdate2).format('ll') }}</span>
                      </p>
                    </div>
                    <div class="when-closed">
                      <span class="relative">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </div>
                    <div class="flex-none when-opened">
                      <span class="relative">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                      </span>
                    </div>
                  </button>
                  <div class="px2 flex flex-wrap">
                    <div class="py1 h6 darkblue gibson">
                      {{ item.opgavetitle }}
                    </div>
                  </div>
                  <div class="px2">
                    <p class="darkblue-background white h6 regular center line-height-golden mb0 gibson p1">
                      <span class="semi-bold">{{ item.reserve }}</span> ud af <span class="semi-bold">{{ item.offer2 }}</span> tilbud
                    </p>
                  </div>
                  <div class="col-12 px2" v-if="item.pidlist.length !== 0">
                    <div class="table-responsive" striped bordered>
                      <table class="table">
                        <thead>
                        <tr>
                          <th>
                            <span class="h6 regular line-height-1 m0">Firma</span>
                          </th>
                          <th>
                            <span class="h6 regular line-height-1 m0">Navn</span>
                          </th>
                          <th>
                            <span class="h6 regular line-height-1 m0">Mobile</span>
                          </th>
                          <th>
                            <span class="h6 regular line-height-1 m0">Email</span>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="pidl in item.pidlist">
                          <td>
                            <span class="h6 regular line-height-1 m0" >{{pidl.company}}</span>
                          </td>
                          <td>
                            <span class="h6 regular line-height-1 m0" >{{pidl.name}}</span>
                          </td>
                          <td>
                            <span class="h6 regular line-height-1 m0" ><a :href="'tel:'+pidl.mobile" >{{pidl.mobile}}</a></span>
                          </td>
                          <td>
                            <span class="h6 regular line-height-1 m0" ><a :href="'mail::'+pidl.email">{{pidl.email}}</a></span>
                          </td>

                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="px2 my2 hide">
                    <select class="col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2" style="height:inherit;font-size:1.25rem!important;">
                      <option value="Select status" selected>Select status</option>
                      <option value="I dialog">I dialog</option>
                      <option value="Vandt opgaven">Vandt opgaven</option>
                    </select>
                  </div>
                  <b-collapse :id="'workDetails'+item.id">
                    <div class="clearfix px2 darkblue gibson">
                      <div class="col-12 px0 mt2">
                        <div class="flex justify-between items-center">
                          <p class="h6 semi-bold darkblue gibson line-height-3 mb2">
                            <span class="block semi-bold">Forventet bemanding</span>
                            <span class="h5 regular">{{ item.numofman2 }} mænd</span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Forventet budget (ex. moms)</span>
                            <span class="h5 regular">{{ item.timepris2 }}&nbsp; </span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Beskrivelse</span>
                            <span class="h5 regular">{{ item.desc2 }} </span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Billeder</span>
                          </p>
                          <div v-for="image in item.imagelist" :key="image">
                            <div class="px2 flex flex-wrap mb2">
                              <b-img :src="image" alt="" style="width:100px;height:100px;"></b-img>
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-wrap">
                          <div class="col-6 px0 mb1">
                            <img src="static/img/one.jpg" alt="" class="fit">
                          </div>
                          <div class="col-6 px0 mb1">
                            <img src="static/img/one.jpg" alt="" class="fit">
                          </div>
                          <div class="col-6 px0 mb1">
                            <img src="static/img/one.jpg" alt="" class="fit">
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
          </div>
        </div>
      </div>
      <!-- desktop setup -->
      <div class="clearfix px2 ml4" v-if="!showMobile">
        <div class="col-12 p2 py3 mb2">
          <div class="clearfix px2">
            <!-- header text and list -->
            <p class="h2 semi-bold line-height-2 mt2 mb1 gibson darkblue">For få opgaver?</p>
            <p class="h5 gibson line-height-3 darkblue regular">– Stil din arbejdskraft til rådighed</p>
            <ul class="list-reset pl0 ml0 mt3">
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Udlån overskydende arbejdskraft</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Optimèr økonomien</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Bevar virksomhedens arbejdsstyrke</p>
              </li>
            </ul>
            <!-- text -->
            <div class="col-12 px0 mt3">
              <p class="h5 regular darkblue line-height-golden mb1 gibson">
                Mange virksomheder oplever i perioder, at de mangler opgaver for at have nok arbejde til alle ansatte. I Mester til Mester kan du stille overskydende arbejdskraft til rådighed for andre medlemmer.
                <span id="dots">...</span>
                <br><br>
                <span id="more">
                  Ved at udlåne arbejdskraft er din virksomhed hele tiden i besiddelse af optimal arbejdsstyrke, men oplever ikke konsekvenserne af mangel på opgaver.
                  <br><br>
                  Når opgaverne kommer ind igen, har du stadig din arbejdsstyrke til at tage varetage opgaverne.
                  <br><br>
                  <strong class="semi-bold">Udlån arbejdskraft i god tid</strong>
                  <br>
                  Forventer du at mangle opgaver i bestemte perioder på året, kan du i god tid udlåne overskydende arbejdskraft. Det skaber vished og sikkerhed i virksomheden i perioder, hvor efterspørgslen ikke er så stor.
                </span>
              </p>
            </div>
            <!-- readmore button -->
            <div @click="readMore()" id="moreBtn" class="clearfix">
              <div class="col-12 px0 flex flex-column justify-center items-center">
                <div class="border green-border shadow green center" style="height:48px;width:48px;border-radius:50%;line-height:48px;border-width:2px!important;">
                  <span id="moreIcon">
                    <i class="el-icon-bottom" style="font-weight:700;font-size:24px;"></i>
                  </span>
                  <span id="lessIcon" style="display:none;">
                    <i class="el-icon-top" style="font-weight:700;font-size:24px;"></i>
                  </span>
                </div>
                <p id="btnText" class="block center green h6 gibson line-height-1 mt1 mb0">Læs mere</p>
              </div>
            </div>
            <!-- filter -->
            <div class="col-16 px0 flex justify-start justify-around items-center">
              <button v-b-toggle.m2m class="col-12 p2 gibson outlined-dark-button not-rounded flex justify-center items-center hide">
                <span class="h4 mb0">Filter</span>
                <span class="flex-none when-closed ml2">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                  </span>
                </span>
                <span class="flex-none when-opened ml2">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <b-collapse id="m2m">
              <div class="clearfix my3">
                <div class="col-12 px0 flex justify-end items-center">
                  <button v-b-toggle.m2m class="white-button border-none not-rounded gibson">
                    <span>
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                    </span>
                  </button>
                </div>
                <div class="py1"></div>
                <b-form-checkbox id="sortByStatus" v-model="status" name="sortByStatus" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Kunder</span>
                </b-form-checkbox>
                <div class="clearfix"></div>
                <b-form-checkbox id="sortByHaveWork" v-model="status" name="sortByHaveWork" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Ledige arbejdskraft</span>
                </b-form-checkbox>
                <div class="clearfix"></div>
                <b-form-checkbox id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="accepted" unchecked-value="not_accepted">
                  <span class="ml1 h5 regular relative" style="top:-3px;">Extra opgaver</span>
                </b-form-checkbox>
                <div class="py1"></div>
                <div class="clearfix">
                  <button class="col-12 action-button p2 gibson not-rounded">
                    <span class="h6 mb0">Sorter nu</span>
                    <span class="ml1"><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </div>
            </b-collapse>
            <!-- create available workfoce / view available workforce -->
            <div class="col col-12 px0 flex justify-between justify-around items-center mt4 pl5">
              <button v-b-toggle.createItem id="setKarft" class="h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span>Opslå ledig arbejdskraft</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </button>
              <button @click="OpenUrl('/markedsplads?mode=job')" id="seeAvailableJobs" class="h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span>Se ledig arbejdskraft</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <!-- success message -->
            <div class="px0 my2" v-if="success">
              <b-alert variant="light" show dismissible fade class="green-background darkblue">
                <p class="h5 gibson semi-bold line-height-3 mt2 mb0">
                  Gennemført!
                </p>
                <p class="h5 regular gibson line-height-golden">
                  Vi håndterer det så hurtigt som muligt
                </p>
              </b-alert>
            </div>
            <!-- create job form in collapse -->
            <b-collapse id="createItem" class="col-7 px0">
              <form>
                <div class="clearfix mt3 mb2">
                  <p class="h4 darkblue gibson line-height-3">
                    Opslå ledige arbejdskraft
                  </p>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Vælg faggruppen
                  </p>
                    <v-select   v-model="opgave2" :options="opgaveoptions" required class="p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                      <template slot="no-options">
                        Ingen matchende ...
                      </template>
                    </v-select>
                    <div class="text-danger" v-if="validationErrors.opgave2 && opgave2 === ''" >Nødvendig</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Antal ledige mænd
                  </p>
                  <input type="number" v-model="numofman2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12">
                  <div class="text-danger" v-if="validationErrors.numofman2 && numofman2 === ''" >Nødvendig</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h5  mediumgrey line-height-1 mb1">
                    Antal tilbud på arbejdskraften
                  </p>
                  <select v-model="offer2" class="lightgrey-background col-12 h5 darkblue px2 py1 outline-none border-none">
                    <option value='3' selected>3 Tilbud</option>
                    <option value='2'>2 Tilbud</option>
                    <option value='1'>1 Tilbud</option>
                  </select>
                  <div class="text-danger" v-if="validationErrors.numofman1 && numofman1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Postnummer (hvor er arbejdskraften)
                  </p>
                  <input type="number" v-model="postnumber2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.postnumber2 && postnumber2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Opstartsdato
                  </p>
                  <date-picker id="ferieStart" type="text" required v-model="startdate2" :config="config" required class="muted-background gibson border-none not-rounded"></date-picker>
                  <div class="text-danger" v-if="validationErrors.startdate2 && startdate2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Timepris inkl. alt (ex. moms)
                  </p>
                  <input type="text" v-model="timepris2" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.timepris2 && timepris2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Skriv om dig
                  </p>
                  <textarea v-model="desc2" class="p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none" style="min-height:120px;" placeholder="Short description"></textarea>
                  <div class="text-danger" v-if="validationErrors.desc2 && desc2 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue line-height-1 mb1">
                    Billeder
                  </p>
                  <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="image in images" :key="image">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                      <button  @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb2">
                  <button type="button" @click="getdataigibility()" class="action-button p2 px3 gibson h4 regular flex justify-center items-center">
                    <span>Fortsæt</span>
                    <span class="ml2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="col-12 px2">
            <div class="flex flex-wrap mt2">
              <div class="col-6 border muted-border shadow p2 pb3 m2" v-for="item in jobs" :key="item.id">
                <button v-b-toggle="'workDetails'+item.id" class="col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1">
                  <div>
                    <svg fill="currentColor" width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"/><path d="M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"/><path d="M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"/></svg>
                  </div>
                  <div class="flex-auto pl2">
                    <p class="darkblue mb0 line-height-1 left-align">
                      <span class="h4 block">Arbejdskraft</span>
                      <span class="h6 regular">Startdato: {{ moment(item.startdate2).format('ll') }}</span>
                    </p>
                  </div>
                  <div class="when-closed">
                    <span class="relative">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </div>
                  <div class="flex-none when-opened">
                    <span class="relative">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </div>
                </button>
                <div class="float-right pr3" >
                  <b-button variant="outline-danger" @click="aflysePerson(item.id)" size="sm">Slet</b-button>
                </div>
                <div class="px2 flex flex-wrap">
                  <div class="py1 h6 darkblue gibson">
                    {{ item.opgavetitle }}
                  </div>
                </div>
                <div class="px2">
                  <p class="darkblue-background white h6 regular center line-height-golden mb0 gibson p1">
                    <span class="semi-bold">{{ item.reserve }}</span> ud af <span class="semi-bold">{{ item.offer2 }}</span> tilbud
                  </p>
                </div>
                <div class="col-12 px2" v-if="item.pidlist.length !== 0">
                  <div class="table-responsive" striped bordered>
                    <table class="table">
                      <thead>
                      <tr>
                        <th>
                          <span class="h6 regular line-height-1 m0">Firma</span>
                        </th>
                        <th>
                          <span class="h6 regular line-height-1 m0">Navn</span>
                        </th>
                        <th>
                          <span class="h6 regular line-height-1 m0">Mobile</span>
                        </th>
                        <th>
                          <span class="h6 regular line-height-1 m0">Email</span>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="pidl in item.pidlist" :key="pidl.id">
                        <td>
                          <span class="h6 regular line-height-1 m0" >{{pidl.company}}</span>
                        </td>
                        <td>
                          <span class="h6 regular line-height-1 m0" >{{pidl.name}}</span>
                        </td>
                        <td>
                          <span class="h6 regular line-height-1 m0" ><a :href="'tel:'+pidl.mobile" >{{pidl.mobile}}</a></span>
                        </td>
                        <td>
                          <span class="h6 regular line-height-1 m0" ><a :href="'mail::'+pidl.email">{{pidl.email}}</a></span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="px2 my2 hide">
                  <select class="col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2" style="height:inherit;font-size:1.25rem!important;">
                    <option value="Select status" selected>Select status</option>
                    <option value="I dialog">I dialog</option>
                    <option value="Vandt opgaven">Vandt opgaven</option>
                  </select>
                </div>
                <b-collapse :id="'workDetails'+item.id">
                  <div class="clearfix px2 darkblue gibson">
                    <div class="col-12 px0 mt2">
                      <div class="flex justify-between items-center">
                        <p class="h6 semi-bold darkblue gibson line-height-3 mb2">
                          <span class="block semi-bold">Forventet bemanding</span>
                          <span class="h5 regular">{{ item.numofman2 }} mænd</span>
                        </p>
                      </div>
                      <div class="mb2">
                        <p class="h6 semi-bold darkblue gibson line-height-3">
                          <span class="block semi-bold">Forventet budget (ex. moms)</span>
                          <span class="h5 regular">{{ item.timepris2 }}&nbsp; </span>
                        </p>
                      </div>
                      <div class="mb2">
                        <p class="h6 semi-bold darkblue gibson line-height-3">
                          <span class="block semi-bold">Beskrivelse</span>
                          <span class="h5 regular">{{ item.desc2 }} </span>
                        </p>
                      </div>
                      <div class="mb2">
                        <p class="h6 semi-bold darkblue gibson line-height-3">
                          Billeder
                        </p>
                        <div v-for="image in item.imagelist" :key="image">
                          <div class="px2 flex flex-wrap mb2">
                            <b-img :src="image" alt="" style="width:100px;height:100px;"></b-img>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-wrap">
                        <div class="col-6 px0 mb1">
                          <img src="static/img/one.jpg" alt="" class="fit">
                        </div>
                        <div class="col-6 px0 mb1">
                          <img src="static/img/one.jpg" alt="" class="fit">
                        </div>
                        <div class="col-6 px0 mb1">
                          <img src="static/img/one.jpg" alt="" class="fit">
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
        </div>
      </div>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </div>
</template>
<script>
// import hotlinemodal from './modals/HotlineModal'
// import archivemodal from './modals/ArchiveModal'
import Haandvaerker from './haandvaerker'
// import { BFormDatepicker } from 'bootstrap-vue'
// Vue.component('b-form-datepicker', BFormDatepicker)
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
// import Imentor from './imentor'
// import { VFBLogin as VFacebookLogin } from 'vue-facebook-login-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import vSelect from 'vue-select'
import Dropzone from 'vue2-dropzone'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'Mester',
  data () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      laborAmount: 3,
      show: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      expectedLabor: 3,
      expectedBids: 3,
      startDate: '',
      status: '',
      shorturl: '',
      endDate: '',
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: false,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      opgaveoptions: [],
      images: [],
      jobs: [],
      validationErrors: {
        opgave1: null,
        subopgave1: null,
        numofman1: null,
        postnumber1: null,
        startdate1: null,
        duration1: null,
        timepris1: null,
        desc1: null,
        opgave2: null,
        numofman2: null,
        postnumber2: null,
        startdate2: null,
        timepris2: null,
        desc2: null
      },
      opgave2: '',
      offer2: '3',
      numofman2: '',
      postnumber2: '',
      startdate2: '',
      timepris2: '',
      desc2: '',
      toolsIncluded: '',
      vehicleIncluded: ''
      // apikey: '',
      // apikeye: '',
      // apikeyb: '',
      // facebookpageid: '',
      // help: '',
      // pdf: '',
      // dineroShow: false,
      // facebookShow: true,
      // facebookShowbox: true,
      // items: [],
      // loginOption: { scope: 'email,manage_pages,publish_pages' },
      // optionsDistance: [],
      // firmaid: '',
      // partnertype: 'SMS-partner',
      // dineroapiupdate: '',
      // economicapiupdate: '',
      // billyapiupdate: '',
      // facebookapiupdate: '',
      // show: false,
      // imentor: true,
      // label: 'Loading...',
      // overlay: 1,
      // haaId: '',
      // salesPerson: ''
    }
  },
  computed: {
    // facebookState () {
    //   return this.facebookpageid.length > 10
    // }
  },
  components: {
    // Imentor,
    // VFacebookLogin,
    Haandvaerker,
    Dropzone,
    vSelect,
    // hotlinemodal,
    // archivemodal,
    loading,
    Simplert,
    datePicker,
    noneligibleFeaturepop
  },
  created () {
    this.eligible = localStorage.getItem('PartnerloginMesterMesterPost')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
    // this.Reload()
    // if (localStorage.getItem('imentor') === '0') {
    //   this.imentor = false
    // }
  },
  methods: {
    getdataigibility (clicktype = 'yes') {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerloginMesterMesterPost')
      } else {
        if (clicktype === 'yes') {
          this.onSubmit()
        }
      }
    },
    onSubmit () {
      if (this.validateForm2()) {
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        var dataPartner = {opgave2: this.opgave2.value, numofman2: this.numofman2, offer2: this.offer2, postnumber2: this.postnumber2, startdate2: this.startdate2, timepris2: this.timepris2, desc2: this.desc2, images: JSON.stringify(this.images)}
        this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savepartnerotherjob&json=no&short=' + this.shorturl, dataPartner, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.show = false
              this.loading = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              if (res.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.success = true
                this.opgave2 = ''
                this.numofman2 = ''
                this.postnumber2 = ''
                this.startdate2 = ''
                this.timepris2 = ''
                this.desc2 = ''
                document.getElementById('setKarft').click()
                this.Reload()
              } else {
                this.show = false
                alert(res.message)
              }
            },
            response => {
              alert('error')
            }
          )
      }
    },
    aflysePerson (id) {
      let confirmFn = function () {
        this.$parent.aflyseconfirm_person(id)
      }
      let obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne arbejdskraft ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    aflyseconfirm_person (id) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'aflyseconfirm_person', salesPerson: this.salesPerson, personid: id}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    OpenUrl (url) {
      this.$router.push(url)
      this.$refs.findworkModal.hide()
    },
    validateForm2 () {
      var success = true
      if (this.opgave2 === '') {
        this.validationErrors.opgave2 = true
        success = false
      }
      if (this.numofman2 === '') {
        this.validationErrors.numofman2 = true
        success = false
      }
      if (this.postnumber2 === '') {
        this.validationErrors.postnumber2 = true
        success = false
      }
      if (this.startdate2 === '') {
        this.validationErrors.startdate2 = true
        success = false
      }
      if (this.timepris2 === '') {
        this.validationErrors.timepris2 = true
        success = false
      }
      if (this.desc2 === '') {
        this.validationErrors.desc2 = true
        success = false
      }
      return success
    },
    updateValue (event) {
      const value = event.target.value
      console.log(value, this.laborAmount)
      if (String(value).length <= 10) {
        this.laborAmount = value
      }
      this.$forceUpdate()
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadImagesMester')
    },
    'showSuccess': function (file) {
      this.images.push(file.xhr.response)
    },
    hideModal () {
      this.$refs.reviewModal.hide()
    },
    hideLaborModal () {
      this.$refs.reviewLaborForm.hide()
    },
    delete_image (image) {
      const index = this.images.indexOf(image)
      if (index > -1) {
        this.images.splice(index, 1)
      }
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_profil_mester', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.opgaveoptions = res.productmesterjob
            this.shorturl = res.urlshort
            this.jobs = res.job
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    readMore () {
      var dots = document.getElementById('dots')
      var moreText = document.getElementById('more')
      var btnText = document.getElementById('btnText')
      var moreIcon = document.getElementById('moreIcon')
      var lessIcon = document.getElementById('lessIcon')
      if (dots.style.display === 'none') {
        dots.style.display = 'inline'
        btnText.innerHTML = 'Læs mere'
        moreText.style.display = 'none'
        moreIcon.style.display = 'inline'
        lessIcon.style.display = 'none'
      } else {
        dots.style.display = 'none'
        btnText.innerHTML = 'Luk'
        moreText.style.display = 'block'
        moreIcon.style.display = 'none'
        lessIcon.style.display = 'inline'
      }
    }
    // getUserData (log) {
    //   console.log(log)
    //   if (log['authResponse']['accessToken']) {
    //     this.show = true
    //     this.salesPerson = localStorage.getItem('id_token_portal')
    //     var dataPartner = {operation: 'service_facebook', salesPerson: this.salesPerson, token: log['authResponse']['accessToken'], userid: log['authResponse']['userID'], expire: log['authResponse']['data_access_expiration_time'], levid: this.haaId}
    //     this.$http.post('', dataPartner, { emulateJSON: true })
    //       .then(
    //         response => {
    //           var res = response.body
    //           this.show = false
    //           if (res.login === false) {
    //             this.$router.push('/login')
    //           }
    //           if (res.success) {
    //             this.modalShowDato = false
    //             let obj = {
    //               title: 'Gennemført!',
    //               message: '',
    //               type: 'success'
    //             }
    //             this.$refs.simplert.openSimplert(obj)
    //             this.Reload()
    //           } else {
    //             alert(res.message)
    //           }
    //         },
    //         response => {
    //           alert('error')
    //         }
    //       )
    //   }
    // },
    // getConnectData (log) {
    //   this.facebookShow = true
    // },
    // service_dinero () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_dinero', salesPerson: this.salesPerson, firmaid: this.firmaid, apikey: this.apikey, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // service_economic () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_economic', salesPerson: this.salesPerson, apikeye: this.apikeye, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // service_billy () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_billy', salesPerson: this.salesPerson, apikeyb: this.apikeyb, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // hideModal () {
    //   this.$refs.dinerowModal.hide()
    // },
    // showModal (pdf) {
    //   this.pdf = pdf
    //   this.$refs.dinerowModal.show()
    // }
  }
}
</script>
<style lang="less">
#more {display: none;}
.vue-dropzone {
  width:100%;
  padding: 0;
  border: 0;
  background: white;
  &:hover {
    background: white!important;
  }
}
.dz-preview {
  display: none!important;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.searchContainer {
  position: relative;
  overflow: hidden;
}
.searchIcon {
  padding: 0.5rem;
}
.text-danger {
  color: red;
  background: #FDD;
  padding: 2px;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(47, 54, 64, 0.5);
}
::-moz-placeholder { /* Firefox 19+ */
  color: rgba(47, 54, 64, 0.5);
}
:-ms-input-placeholder { /* IE 10+ */
  color: rgba(47, 54, 64, 0.5);
}
:-moz-placeholder { /* Firefox 18- */
  color: rgba(47, 54, 64, 0.5);
}
.white-border {
  border-color: white!important;
}
</style>



// WEBPACK FOOTER //
// MesterArbejdskraft.vue?f5b14158